/* eslint-disable max-len */
import { connect } from 'react-redux';
import FriendRequestItem from './FriendRequestItem';
import { fetchWithAccessToken } from '../../actions/helperAction';
import { acceptFriendRequest } from '../../actions/friendRequestsAction';

const mapStateToProps = () => ({});

const mapDispachToProps = (dispatch) => ({
  onAnswerFriendRequest: (request) => dispatch(acceptFriendRequest(request)),
  onFetch: ({ url, method, body }) => dispatch(fetchWithAccessToken({ url, method, body })),
});

export default connect(mapStateToProps, mapDispachToProps)(FriendRequestItem);
